module.exports = __webpack_public_path__ + "static/img/indexw.ab68567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexw.png
// module id = SVs4
// module chunks = 1